/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMouse = createReactComponent("outline", "mouse", "IconMouse", [["path", { "d": "M6 3m0 4a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-4a4 4 0 0 1 -4 -4z", "key": "svg-0" }], ["path", { "d": "M12 7l0 4", "key": "svg-1" }]]);

export { IconMouse as default };
//# sourceMappingURL=IconMouse.mjs.map
